import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';
import type { MessageReactions as MessageReactionsMap } from '@/hooks/useUserMessages';
import { cn } from '@/lib/utils';

interface MessageReactionsProps {
  reactions?: MessageReactionsMap | null;
  onToggleReaction: (emoji: string, imageUrl?: string) => void;
}

export default function MessageReactions({ reactions, onToggleReaction }: MessageReactionsProps) {
  const { user } = useAuth();

  if (!reactions || Object.keys(reactions).length === 0) {
    return null;
  }

  return (
    <div className="mt-2 flex flex-wrap gap-1.5">
      {Object.entries(reactions).map(([emoji, data]) => {
        if (!data?.user_ids?.length) {
          return null;
        }

        const currentUserReacted = user ? data.user_ids.includes(user.id) : false;

        return (
          <Button
            key={emoji}
            type="button"
            variant="outline"
            size="sm"
            className={cn(
              'h-auto rounded-full border-border/70 bg-background/80 px-2 py-1 text-xs shadow-sm hover:bg-accent hover:text-accent-foreground',
              currentUserReacted && 'border-primary/50 bg-accent/60 text-accent-foreground'
            )}
            onClick={() => onToggleReaction(emoji, data.imageUrl)}
          >
            {data.imageUrl ? (
              <img src={data.imageUrl} alt={emoji} className="mr-1.5 h-4 w-4" />
            ) : (
              <span className="mr-1.5 text-sm leading-none">{emoji}</span>
            )}
            <span className="font-semibold leading-none">{data.user_ids.length}</span>
          </Button>
        );
      })}
    </div>
  );
}
